import { useId } from "react";
import type { QuestionProps } from "../types";
import { QuestionShell } from "./QuestionShell";
import { Textarea } from "@/components/ui/textarea";

export function LongText(props: QuestionProps) {
  const id = useId();
  const { value, onChange, disabled } = props;
  return (
    <QuestionShell props={props} inputId={id}>
      {({ helpId }) => (
        <Textarea
          id={id}
          aria-describedby={helpId}
          rows={5}
          value={typeof value === "string" ? value : ""}
          disabled={disabled}
          maxLength={10000}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
    </QuestionShell>
  );
}
